import { render } from "./ElearnList.vue?vue&type=template&id=610dbd26"
import script from "./ElearnList.vue?vue&type=script&lang=js"
export * from "./ElearnList.vue?vue&type=script&lang=js"
script.render = render

export default script